import { HeaderRankBar } from '@/components/trophies/HeaderRankBar'

export function Header() {
  return <HeaderRankBar />
}
